export default __webpack_public_path__ + "static/media/nLogo.svg";